module.exports = __webpack_public_path__ + "img/QR_Proxima.c7c29f80.png";